import { notifyReportFailure } from '@/modules/report_server/infra/vue2_report_printer';
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import Vuex from 'vuex'
import router from './router'
import store from './store'
import { Amplify } from '@aws-amplify/core';
import awsconfig from './aws-exports';
import vmodal from 'vue-js-modal';
import VueMeta from 'vue-meta'
// import * as Sentry from "@sentry/vue";
// import { BrowserTracing } from "@sentry/tracing";
// import Profiler from "./utils/profiler"
import i18n from './i18n'
import { initializeConstants } from './store/constants'
import AppIcon from '@/components/layout/AppIcon.vue'

Amplify.configure(awsconfig);

// Initialize tax constants from backend (lazy loading)
// This will load taxes in the background without blocking app initialization
if (!['/report-invoice', '/report-invoice-dynamic'].includes(window.location.pathname.replace(/\/$/, ''))) {
  initializeConstants().catch(() => {
    console.warn('Failed to preload taxes from backend, using defaults')
  });
}
//Vue.mixin(Profiler)
Vue.use(Vuex)
Vue.use(vmodal)
Vue.use(VueMeta)

// Register AppIcon globally so it can be used without importing
Vue.component('AppIcon', AppIcon)

// Sentry.init({
// 	Vue,
// 	dsn: "https://02ba0865bd0e4c2a82be8ad1c1e955cf@o1182848.ingest.sentry.io/6301142",
// 	integrations: [
// 	  new BrowserTracing({
// 		routingInstrumentation: Sentry.vueRouterInstrumentation(router),
// 		tracingOrigins: ["app.inmatic.ai", /^\//],
// 	  }),
// 	],
// 	// Set tracesSampleRate to 1.0 to capture 100%
// 	// of transactions for performance monitoring.
// 	// We recommend adjusting this value in production
// 	tracesSampleRate: 0.01,
// });

Vue.config.productionTip = false
if (window.__isTechnicalReport) {
    Vue.config.errorHandler = () => {
        console.error('Report rendering failed');
        notifyReportFailure('render');
    };
}
export const bus = new Vue();
new Vue({
	store,
	vuetify,
	router,
	i18n,
	render: h => h(App)
}).$mount('#app')
